import { ClickPopper } from "@client/components/utils/ClickPopper";
import KebabMenuIcon from "@client/icons/KebabMenuIcon";

export const ActionButton = ({
  onClick,
  isActive,
  activeText,
  inactiveText,
}: {
  onClick: () => void;
  isActive: boolean;
  activeText: string;
  inactiveText: string;
}) => {
  return (
    <button
      className="dark:text-white dark:bg-stone-800 rounded-none hover:bg-stone-200 dark:hover:bg-stone-400 p-2"
      onClick={onClick}
    >
      {isActive ? activeText : inactiveText}
    </button>
  );
};

export function TrancheMenu({
  onModalOpen,
  onModalClose,
  addTrancheBefore,
  addTrancheAfter,
  cancelNewTranche,
  deleteTranche,
}: {
  onModalOpen?: () => void;
  onModalClose?: () => void;
  addTrancheBefore?: () => void;
  addTrancheAfter?: () => void;
  cancelNewTranche?: () => void;
  deleteTranche?: () => void;
}) {
  // const canEvaluatorEvaluationMVFChange = evaluator
  //   ? useCheckPermissions("EvaluatorEvaluationMVFChange", {
  //       roundId: round.id,
  //       evaluatorId: evaluator.id,
  //       evaluableId: "",
  //       mvf: { fdv: 0, conc: 0, ldt: 0, type: "curve" },
  //     })
  //   : false;

  const canEvaluatorEvaluationMVFChange = true;

  const showKebab = canEvaluatorEvaluationMVFChange;

  return (
    <div>
      {showKebab && (
        <ClickPopper
          placement="right-start"
          onHide={() => onModalClose && onModalClose()}
          onShow={() => onModalOpen && onModalOpen()}
          title={
            <div className="flex flex-col w-48">
              {addTrancheBefore && (
                <ActionButton
                  onClick={addTrancheBefore}
                  isActive={true}
                  activeText="Add Tranche Before"
                  inactiveText=""
                />
              )}
              {addTrancheAfter && (
                <ActionButton
                  onClick={addTrancheAfter}
                  isActive={true}
                  activeText="Add Tranche After"
                  inactiveText=""
                />
              )}
              {cancelNewTranche && (
                <ActionButton
                  onClick={cancelNewTranche}
                  isActive={true}
                  activeText="Cancel New Tranche"
                  inactiveText=""
                />
              )}
              {deleteTranche && (
                <ActionButton
                  onClick={deleteTranche}
                  isActive={true}
                  activeText="Delete Tranche"
                  inactiveText=""
                />
              )}
              {/* {false && (
                <ActionButton
                  onClick={swapWithTrancheAbove}
                  isActive
                  activeText="Swap With Previous Tranche"
                  inactiveText=""
                />
              )}
              {false && (
                <ActionButton
                  onClick={swapWithTrancheBelow}
                  isActive
                  activeText="Swap With Next Tranche"
                  inactiveText=""
                />
              )} */}
            </div>
          }
        >
          <KebabMenuIcon className="mx-auto cursor-pointer" />
        </ClickPopper>
      )}
    </div>
  );
}
